export default __webpack_public_path__ + "static/media/FormImg.16c14e46.png";